
import React from "react";
import { useMediaQuery } from 'react-responsive'
import logo from './Assets/Images/logoEstacaoHeader.png';
import logotypeOnly from './Assets/Images/logotypeOnly.png';
import './App.css';




import { Helmet } from 'react-helmet';
import SafariWarningModal from './Components/SafariWarningModal'
import UserWayWidget from './Components/UserWayWidget';
import { FloatingWhatsApp } from 'react-floating-whatsapp'

//theme
//import "./Assets/Styles/theme-primereact.css"; 

//core
import "primereact/resources/primereact.min.css";

// Estilo base do PrimeReact
import 'primereact/resources/primereact.min.css';

// Tema (pode escolher outro se quiser)
import 'primereact/resources/themes/saga-blue/theme.css'; 

//icons
import "primeicons/primeicons.css";  

import DesktopLayout from './Layouts/Desktop';
import MobileLayout from './Layouts/Mobile';

//import ReCAPTCHA from "react-google-recaptcha"
import * as Config from './Config/api';

import TagManager from 'react-gtm-module'
const tagManagerArgs = {
  gtmId: 'GTM-N6WLHKV5'
}
TagManager.initialize(tagManagerArgs);

function App() {

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1024px)'
  })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })	
	
  //const recaptchaRef = React.useRef(null);
	
  return (
    <div className="App">
    <SafariWarningModal />

    <Helmet>
      <title>Estação de Olho - A saúde ocular chegou para todos </title>
      <meta name="description" content="Especialistas em saúde ocular e oftalmologia avançada." />
      <meta name="keywords" content="oftalmologia, clínica, saúde ocular, exames de vista" />
    </Helmet>
    
		<div>
			{isDesktopOrLaptop && <DesktopLayout />}
			{isTabletOrMobile && <MobileLayout />}
		</div>
      {/*<ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
		    badge="bottomleft" 
        sitekey={Config.REACT_APP_SITE_KEY}
      />*/}	
      <UserWayWidget />	

      <FloatingWhatsApp
        phoneNumber="+5521976121000"
        accountName="Estação de Olho"
        allowClickAway={true}
        chatMessage="👁️ Olá! Sou a Lia, concierge virtual da estação do olho. Quer agendar sua cirurgia ocular com preço acessível e facilidade? Fale comigo!"
        statusMessage="Fale conosco quando precisar"
        placeholder="Digite sua mensagem aqui..."
        avatar={logotypeOnly}
        notification={true}
        notificationSound={true}
        notificationDelay={5000}
        style={{ bottom: '5rem', right: '20px' }}
       />

    </div>
  );
}

export default App;
